import {
  jb_text_field_css_default
} from "./chunk.4O7LC4J7.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.TQSPBGH7.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  applyStyles
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-text-field/jb-text-field.ts
var JbTextField = class extends Initiable(FormElement(i)) {
  constructor() {
    super(...arguments);
    this._currentLength = 0;
    this._showEmailError = false;
  }
  connectedCallback() {
    super.connectedCallback();
    applyStyles(this, jb_text_field_css_default);
  }
  createRenderRoot() {
    return this;
  }
  validate() {
    let valid = super.validate();
    if (valid && this.type === "email") {
      this._showEmailError = this.value === "" && this.requiredText === "" ? false : !this.validateEmail();
      valid = !this._showEmailError;
    }
    return valid;
  }
  validateEmail() {
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(this.value).toLowerCase());
  }
  _handleInput(e2) {
    this.value = e2.target.value;
    if (this.maxLength) {
      this._currentLength = this.value.length;
    }
  }
  _handleInputChange(e2) {
    this.value = e2.target.value;
    this._currentLength = this.value.length;
    this.validate();
  }
  render() {
    return b`
      <div class=${e({ white: !!this.isWhite, hidden: this.type === "hidden" })}>
        <input
          class=${e({
      optional: this.requiredText === "" || !this.requiredText,
      error: this.showError || this._showEmailError || !!this.errorText
    })}
          ?disabled=${this.disabled}
          .name=${this.name}
          ?required=${!!this.requiredText}
          .value=${typeof this.value === "string" ? this.value : ""}
          .type=${this.type}
          .id=${this.name}
          list=${this.list ?? A}
          placeholder="${this.placeholder}${this.requiredText ? "*" : ""}"
          .autocomplete=${this.autocomplete ?? "on"}
          @change=${this._handleInputChange}
          .maxLength=${this.maxLength ?? A}
          @input=${this._handleInput}
          aria-label=${this.label}
          aria-errormessage=${this.showError || this.errorText || this._showEmailError ? `${this.name}_error` : A}
          aria-invalid="${this.showError || this.errorText || this._showEmailError ? "true" : "false"}"
        />
        ${this.maxLength ? b`<div class="counter">
                <span>${this.maxLengthText ?? A}</span><span>${this._currentLength} / ${this.maxLength}</span>
              </div>` : A}
        <label
          for=${this.name}
          id="${this.name}_label"
          >${this.label}${this.requiredText ? "*" : ""}</label
        >
        <div id="${this.name}_error">
          ${this.showError || this.errorText || this._showEmailError ? b`<p>
                  ${this.showError ? b`<span>${this.requiredText}</span>` : A}
                  ${this.errorText ? b`<span>${this.errorText}</span>` : A}
                  ${!this.showError && this._showEmailError ? b`<span>${this.emailErrorText}</span>` : A}
                </p>` : A}
        </div>
      </div>
    `;
  }
};
JbTextField.styles = [reset_css_default, jb_text_field_css_default];
__decorateClass([
  n()
], JbTextField.prototype, "autocomplete", 2);
__decorateClass([
  n()
], JbTextField.prototype, "emailErrorText", 2);
__decorateClass([
  n({ type: Boolean })
], JbTextField.prototype, "isWhite", 2);
__decorateClass([
  n()
], JbTextField.prototype, "list", 2);
__decorateClass([
  n({ type: Number })
], JbTextField.prototype, "maxLength", 2);
__decorateClass([
  n()
], JbTextField.prototype, "maxLengthText", 2);
__decorateClass([
  n()
], JbTextField.prototype, "placeholder", 2);
__decorateClass([
  n()
], JbTextField.prototype, "type", 2);
__decorateClass([
  r()
], JbTextField.prototype, "_currentLength", 2);
__decorateClass([
  r()
], JbTextField.prototype, "_showEmailError", 2);
JbTextField = __decorateClass([
  customElement("jb-text-field")
], JbTextField);

export {
  JbTextField
};
